module.exports = __webpack_public_path__ + "img/banner-25.b7a8d371.jpg";